
import { useIdMixin } from '@teamnovu/utils'

export default {
  mixins: [useIdMixin({ name: 'uniqueId' })],

  inject: ['wizard'],

  props: {
    page: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      stepsWrapperId: `wizard-steps-${this.uniqueId}`,
      stepsOpenOnMobile: false,
    }
  },

  created() {
    if (!this.wizard) {
      throw new Error('WizardSteps must be a descendant of a Wizard')
    }
  },
}
